/**
 * Join class names, dropping the falsy ones.
 *
 * Volto core uses `classnames` for this, but core's dependencies are core's:
 * a package under packages/ resolves only what it declares. Rather than take a
 * runtime dependency to concatenate strings, this is the four lines of it that
 * these three components use.
 */
const cx = (...args) =>
  args
    .flatMap((arg) =>
      arg && typeof arg === 'object' && !Array.isArray(arg)
        ? Object.entries(arg)
            .filter(([, on]) => on)
            .map(([name]) => name)
        : arg,
    )
    .filter(Boolean)
    .join(' ');

export default cx;
